// src/utils/token/token.js

import axios from "../../utils/api/axios";
import { OAUTH_TOKEN, CLIENT_ID, CLIENT_SECRET } from "../Config"; // 환경설정 import
import { setCookie, getCookie, deleteCookie } from '../cookies/cookies.js';

export async function refreshAccessToken() {
    const refreshToken = getCookie("refresh_token");

    if (!refreshToken) {
        return null; // 갱신 실패
    }

    try {

        const tokenConfig = {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
            client_id: CLIENT_ID,
            client_secret: CLIENT_SECRET,
        };
        const tokenQueryString = new URLSearchParams(tokenConfig).toString();

        const res = await axios.post(`${OAUTH_TOKEN}?${tokenQueryString}`, null, {withCredentials: true});

        const { access_token, expires_in, refresh_token: newRefreshToken, exp_timestamp, refresh_token_expires_in } = res.data;

        let finalExpiresIn;
        if (exp_timestamp) {
            finalExpiresIn = exp_timestamp; // 서버에서 제공한 절대 만료 시간
        } else {
            finalExpiresIn = Date.now() + (expires_in * 1000);
        }

        // sessionStorage 업데이트
        // setCookie("access_token", access_token, 1);
        // setCookie("tokenExpiresIn", finalExpiresIn.toString(), 1); // 숫자를 문자열로 저장
        // if (newRefreshToken) setCookie("refresh_token", newRefreshToken, 1); // 새 refresh token이 제공되면 업데이트

        // AuthContext 업데이트
        // saveToken(access_token, finalExpiresIn);
        // saveRefreshToken(newRefreshToken, refresh_token_expires_in);
        // saveTokenExpiresIn(finalExpiresIn);
        // saveAuthenticated(true); // 인증 상태 유지
        // saveRole(res.data.roles); // 토큰 갱신 시 역할이 변경될 수도 있다면 업데이트
        // saveUser(res.data.user); // 토큰 갱신 시 사용자 정보가 변경될 수도 있다면 업데이트

        return res.data;// 갱신 성공
    } catch (e) {
        console.error("Failed to refresh access token:", e);
        return null; // 갱신 실패
    }
}

export function clearAuthCookies() {
    sessionStorage.clear(); // localStorage 대신 sessionStorage 사용
    localStorage.clear();
    deleteCookie('accessToken');
    deleteCookie('refresh_token');
    deleteCookie('tokenExpiresIn');
    deleteCookie('role');
    deleteCookie('user');
    deleteCookie('user_id');
}

